export const baseURL = "https://ferrywheel-api.tikkiearn.com/";
export const adminBaseURL = "https://admin-api.tikkiearn.com/";
export const key = "H4cZuS9uj;QpSrVh";
